import { Action, AdvisoryContent, ViewElement } from '../../../common/global-types/AdvisoryContent';
import APIUtil from '../../../common/api/APIUtil';
import useTracking from '../../../common/tracking/useTracking';
import useViewPairing from '../modal/useViewPairing';
import { ContentTipModalView } from './Tips';
import { getIconSizing } from '../../../common/components/action/IconSize';

type TipProps = {
  content: AdvisoryContent;
  proxyPath: string | null;
  setContentTipModalViews: React.Dispatch<React.SetStateAction<ContentTipModalView[]>>;
  tipViewId: number;
};

function Tip({
  content, proxyPath, setContentTipModalViews, tipViewId
}: TipProps) {
  const { primaryViewId } = useViewPairing(
    tipViewId,
    content.contentViews!,
    content.initialView
  );

  const trackVisibilityElement = useTracking(content, primaryViewId);

  const currentView = content.contentViews?.find((c) => c.contentViewId === primaryViewId)!.viewElements as ViewElement;

  function handleOnClick(action: Action) {
    if (action.callbackPath) APIUtil.handleCallbackUrl(proxyPath, action.callbackPath);

    let tipViewId: number | undefined = undefined;
    let modalViewId: number | undefined = undefined;

    if (action.loadView) tipViewId = action.loadView!;

    if (content.contentViews?.find((c) => c.contentViewId === action.loadView)?.isModal) modalViewId = action.loadView!;

    setContentTipModalViews((prev: ContentTipModalView[]) => {
      return prev.map((view) =>
        content.id === view.contentId ? { ...view, tipViewId: tipViewId ?? view.tipViewId, modalViewId: modalViewId } : view
      );
    });
  }

  function isEmptyOrWhitespace(str: string | null | undefined): boolean {
    return !str || str.trim().length === 0;
  }

  return (
    <li key={currentView.headlines[0]} className="if card elevated">
      <div className="advisory-tip-top">
        {currentView.icons && (
          <div className="advisory-icon-wrapper">
            <ids-icon {...{ [currentView.icons[0].name]: true, [`${currentView.icons[0].group}-24`]: true }} />
          </div>
        )}
        <h5 ref={trackVisibilityElement} className="if typography heading xx-small">
          {currentView.headlines[0]}
        </h5>
        {currentView.paragraphs && <p className="if typography paragraph medium">{currentView.paragraphs[0]}</p>}
      </div>
      <div className="advisory-tip-bottom">
        {currentView.actions && currentView.actions.map((action) => (action.url ? (
          <a
            key={action.text}
            className={isEmptyOrWhitespace(action.idsClassName) ? "if link standalone" : action.idsClassName} 
            href={action.url}
            target={action.target ?? '_self'}
            onClick={() => handleOnClick(action)}
          >
            {action.text}
            {action.idsIconName && action.idsIconGroup && (
              <ids-icon {...{ [action.idsIconName]: true, [`${action.idsIconGroup}-${getIconSizing(action.idsClassName)}`]: true }} />
            )}
          </a>
        ) : (
          <button
            key={action.text}
            type="button"
            className={action.idsClassName || undefined}
            onClick={() => handleOnClick(action)}
          >
            {action.text}
            {action.idsIconName && action.idsIconGroup && (
              <ids-icon {...{ [action.idsIconName]: true, [`${action.idsIconGroup}-${getIconSizing(action.idsClassName)}`]: true }} />
            )}
          </button>
        )))}
        {currentView.media?.[0]
          && <img src={currentView.media[0].url} alt={currentView.media[0].alt} className="if image" />}
      </div>
    </li>
  );
}

export default Tip;
